import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import {
  getMetricsV3,
  getTeamGoalsDashboard
} from 'common/services/metrics.service';
import { GOALS_METRICS } from '../components/GoalsAndBenchmarks/goals.service';
import {
  today,
  GOALS_PERIOD,
  metricsStartPeriodDate
} from '../teamDashboardCurrentIterationV2.service';
import {
  numOfDaysInIterationSelector,
  isIterationsPeriodKeySelectedSelector
} from 'state/selectors/ui-state';
import { VIEW_PATH_KEYS } from 'common/constants/constants';
import { getIsGitScopeByKey } from 'components/TeamGitScopeBanner/utils';
import { useDebounceCallback } from '@react-hook/debounce';

const useGoals = ({ selectedTeamId, gitScopeToggle }) => {
  const [goals, setGoals] = useState([]);
  const [teamDashboardWidgets, setTeamDashboardWidgets] = useState(null);
  const [teamDashboardId, setTeamDashboardId] = useState(null);
  const isIterationsPeriodKeySelected = useSelector(
    isIterationsPeriodKeySelectedSelector
  );
  // goalsPeriod: If numOfDaysInRange < 30 - use 30; else - use numOfDaysInRange
  const numOfDaysInRange = useSelector(numOfDaysInIterationSelector);
  const isGoalsDefaultPeriod =
    GOALS_PERIOD >= numOfDaysInRange || isIterationsPeriodKeySelected;
  const goalsPeriod = isGoalsDefaultPeriod ? GOALS_PERIOD : numOfDaysInRange;

  const getGoals = async (gitScopeToggle = null) => {
    const time_ranges = [
      { after: metricsStartPeriodDate(goalsPeriod), before: today }
    ];
    const goals = await getMetricsV3({
      offset: 0,
      roll_up: 'custom',
      time_ranges,
      team_ids: [selectedTeamId],
      group_by: 'team',
      return_no_data: true,
      requested_metrics: GOALS_METRICS.map(name => ({ name })),
      ...(gitScopeToggle !== null
        ? {
            team_git_scope_disabled: !getIsGitScopeByKey(
              gitScopeToggle,
              VIEW_PATH_KEYS.DASHBOARD
            )
          }
        : {})
    });

    const goalsData = _.get(goals, '[0].data');

    setGoals(goalsData);
  };

  const getTeamDashboard = async () => {
    const { widgets = [], teamDashboardId } = await getTeamGoalsDashboard(
      selectedTeamId
    );
    setTeamDashboardWidgets(widgets.map(({ id }) => id));
    setTeamDashboardId(teamDashboardId);
  };

  useEffect(() => {
    getTeamDashboard();
  }, [selectedTeamId]);

  const debouncedGetGoals = useDebounceCallback(
    gitScopeToggle => getGoals(gitScopeToggle),
    300
  );

  useEffect(() => {
    debouncedGetGoals(gitScopeToggle);
  }, [selectedTeamId, goalsPeriod, gitScopeToggle]);

  return { goals, teamDashboardId, teamDashboardWidgets, isGoalsDefaultPeriod };
};

export default useGoals;
